module.exports = __webpack_public_path__ + "static/media/pg1.2025eaba.jpg";